import React from 'react';
import './Header.css';

const Header = ({ onClick }) => (
    <header>
        <img src="/images/juan.webp" alt="Juan González" width="80" onClick={(e) => e.target.classList.toggle('active')} />

        <div className="header__content">
            <div className="header__title">
                <h1>Juan González</h1>
                <h2>Senior UI designer & developer</h2>
            </div>
        </div>
    </header>
);

export default Header;
